import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca6f76ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sold out!", -1))
const _hoisted_3 = { key: 4 }
const _hoisted_4 = ["data-network"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sorry, there are no tokens left to redeem.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "You are not eligible for this burn.", -1))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "campaign-action-transaction"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tx-link text-green-400" }, "VIEW YOUR REDEEM TX ON ETHERSCAN", -1))
const _hoisted_14 = {
  key: 3,
  class: "campaign-action-transaction"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tx-link text-green-400" }, " View Your Redemption on OpenSea ", -1))

import { ExternalLinkIcon, ArrowRightIcon } from '@heroicons/vue/solid';
import {
  computed, onMounted, ref,
} from 'vue';
import Alert from '@/components/Alert.vue';
import { AuthState } from '@/store/modules/account.store';
import { useAccount } from '@/composables/useAccount';
import Spinner from '@/components/Spinner.vue';
import { useInjectTopLevelProps } from '@/exports/MBurnRedeemCompleteWidgetProps';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import calendar from 'dayjs/plugin/calendar';
import { useBR } from '@/composables/useBR';

// @dev: gives us access to dayjs().fromNow()
interface ActionProps {
  errorMsg?: string;
  txHash: string;
  mintedTokenId: string;
  status: 'not-started' | 'ended' | 'enabled' | null;
  supplyLeft: number;
  allowBurning: boolean;
  burnRedeemTxStatus: 'error' | 'loading' | 'idle' | 'success';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Action',
  props: {
    errorMsg: null,
    txHash: null,
    mintedTokenId: null,
    status: null,
    supplyLeft: null,
    allowBurning: { type: Boolean },
    burnRedeemTxStatus: null
  },
  emits: ['numberToRedeemChanged', 'callToAction'],
  setup(__props: any, { emit }) {

dayjs.extend(relativeTime);
// @dev: gives us access to dayjs().calendar()
dayjs.extend(calendar);



const { authState } = useAccount();
const { network } = useInjectTopLevelProps();
const { burn, redeemContractAddress } = useBR();
const showConnect = ref(false);

const isSoldOut = computed(() => {
  return (
    burn
    && burn.value?.totalSupply
    && burn.value?.totalSupply > 0
    && burn.value?.totalSupply === burn.value?.redeemedCount
  );
});

// TODO: this system should only apply on mobile
const handleScroll = () => {
  showConnect.value = true;
  document.querySelector('.m-burn-redeem-complete')?.removeEventListener('scroll', handleScroll);
};

onMounted(() => {
  document.querySelector('.m-burn-redeem-complete')?.addEventListener('scroll', handleScroll);
});

const callToAction = () => {
  // @dev: when we're opening the 721 Modal where we don't have a number input
  emit('callToAction', 1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["campaign-action", {
      'show-connect': showConnect.value,
      'campaign-action-disabled': !__props.allowBurning,
    }])
  }, [
    (!!__props.errorMsg && __props.errorMsg.length)
      ? (_openBlock(), _createBlock(Alert, {
          key: 0,
          type: "error"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", { innerHTML: __props.errorMsg }, null, 8, _hoisted_1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.status === 'not-started' && _unref(burn)?.startDate)
      ? (_openBlock(), _createBlock(Alert, {
          key: 1,
          type: "error"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, " This burn starts on " + _toDisplayString(_unref(dayjs)(_unref(burn)?.startDate * 1000).calendar()) + ".", 1)
          ]),
          _: 1
        }))
      : (__props.status === 'ended' && _unref(burn)?.endDate)
        ? (_openBlock(), _createBlock(Alert, {
            key: 2,
            type: "error"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, "This burn ended " + _toDisplayString(_unref(dayjs)(_unref(burn)?.endDate * 1000).fromNow()) + ".", 1)
            ]),
            _: 1
          }))
        : (_unref(isSoldOut))
          ? (_openBlock(), _createBlock(Alert, {
              key: 3,
              type: "info"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_unref(authState) !== _unref(AuthState).LOGGED_IN)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    "data-widget": "m-connect",
                    "data-app-name": "Burn Redeem Widget",
                    "data-client-id": "7f0492bab27e2547c5ee615a32a66f1301bf47cd75676afe38b2978f3f626403",
                    "data-multi": "true",
                    "data-grant-type": "signature",
                    "data-network": _unref(network),
                    "data-show-chain": "false",
                    "data-show-balance": "false",
                    "data-override-connect-text": "Connect",
                    "data-auto-reconnect": "false",
                    "data-message": "Please sign this message to use this Manifold Burn Redeem page and allow us to view your eligible NFTs."
                  }, null, 8, _hoisted_4))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_unref(burn)?.totalSupply !== 0 && _unref(burn) && _unref(burn).redeemedCount === _unref(burn)?.totalSupply)
                      ? (_openBlock(), _createBlock(Alert, {
                          key: 0,
                          type: "info"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(authState) === _unref(AuthState).LOGGED_IN && !__props.allowBurning)
                      ? (_openBlock(), _createBlock(Alert, {
                          key: 1,
                          type: "info"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      disabled: !__props.allowBurning,
                      class: "campaign-action-button",
                      onClick: callToAction
                    }, [
                      (__props.burnRedeemTxStatus !== 'loading')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Select Tokens To Burn "))
                        : _createCommentVNode("", true),
                      (__props.burnRedeemTxStatus == 'loading')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Redeeming... "))
                        : _createCommentVNode("", true),
                      (__props.burnRedeemTxStatus == 'loading')
                        ? (_openBlock(), _createBlock(Spinner, { key: 2 }))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(ArrowRightIcon), { class: "h-4" })
                    ], 8, _hoisted_8),
                    (__props.txHash.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("a", {
                            href: `https://${_unref(network) === 5 ? 'goerli.' : 'www.'}etherscan.io/tx/${__props.txHash}`,
                            target: "_blank"
                          }, [
                            _hoisted_13,
                            _createVNode(_unref(ExternalLinkIcon), { class: "link-icon text-green-400" })
                          ], 8, _hoisted_12)
                        ]))
                      : _createCommentVNode("", true),
                    (
            _unref(burn) &&
              __props.txHash.length > 0 &&
              __props.burnRedeemTxStatus !== 'loading' &&
              __props.mintedTokenId &&
              _unref(redeemContractAddress)
          )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("a", {
                            href: `https://${_unref(network) === 5 ? 'testnets.' : ''}opensea.io/${
              _unref(network) === 5 ? 'assets/goerli' : 'assets/ethereum'
            }/${_unref(redeemContractAddress)}/${__props.mintedTokenId}`,
                            target: "_blank"
                          }, [
                            _hoisted_16,
                            _createVNode(_unref(ExternalLinkIcon), { class: "link-icon text-green-400" })
                          ], 8, _hoisted_15)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ]))
  ], 2))
}
}

})